import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import webauthn from './webauthn'
import enroll47ba96 from './enroll'
/**
* @see \App\Http\Controllers\AuthEnrollmentController::enroll
 * @see app/Http/Controllers/AuthEnrollmentController.php:81
 * @route '/login/two-factor/enroll/enroll'
 */
export const enroll = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: enroll.url(options),
    method: 'get',
})

enroll.definition = {
    methods: ["get","head"],
    url: '/login/two-factor/enroll/enroll',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthEnrollmentController::enroll
 * @see app/Http/Controllers/AuthEnrollmentController.php:81
 * @route '/login/two-factor/enroll/enroll'
 */
enroll.url = (options?: RouteQueryOptions) => {
    return enroll.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthEnrollmentController::enroll
 * @see app/Http/Controllers/AuthEnrollmentController.php:81
 * @route '/login/two-factor/enroll/enroll'
 */
enroll.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: enroll.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthEnrollmentController::enroll
 * @see app/Http/Controllers/AuthEnrollmentController.php:81
 * @route '/login/two-factor/enroll/enroll'
 */
enroll.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: enroll.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthEnrollmentController::enroll
 * @see app/Http/Controllers/AuthEnrollmentController.php:81
 * @route '/login/two-factor/enroll/enroll'
 */
    const enrollForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: enroll.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthEnrollmentController::enroll
 * @see app/Http/Controllers/AuthEnrollmentController.php:81
 * @route '/login/two-factor/enroll/enroll'
 */
        enrollForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: enroll.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthEnrollmentController::enroll
 * @see app/Http/Controllers/AuthEnrollmentController.php:81
 * @route '/login/two-factor/enroll/enroll'
 */
        enrollForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: enroll.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    enroll.form = enrollForm
/**
* @see \App\Http\Controllers\AuthController::auth
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
export const auth = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: auth.url(options),
    method: 'get',
})

auth.definition = {
    methods: ["get","head"],
    url: '/login/two-factor/auth',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::auth
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
auth.url = (options?: RouteQueryOptions) => {
    return auth.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::auth
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
auth.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: auth.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::auth
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
auth.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: auth.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::auth
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
    const authForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: auth.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::auth
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
        authForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: auth.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::auth
 * @see app/Http/Controllers/AuthController.php:401
 * @route '/login/two-factor/auth'
 */
        authForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: auth.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    auth.form = authForm
/**
* @see \App\Http\Controllers\AuthController::recovery
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
export const recovery = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: recovery.url(options),
    method: 'post',
})

recovery.definition = {
    methods: ["post"],
    url: '/login/two-factor/recovery',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::recovery
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
recovery.url = (options?: RouteQueryOptions) => {
    return recovery.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::recovery
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
recovery.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: recovery.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::recovery
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
    const recoveryForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: recovery.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::recovery
 * @see app/Http/Controllers/AuthController.php:627
 * @route '/login/two-factor/recovery'
 */
        recoveryForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: recovery.url(options),
            method: 'post',
        })
    
    recovery.form = recoveryForm
/**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
export const requestCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestCode.url(args, options),
    method: 'get',
})

requestCode.definition = {
    methods: ["get","head"],
    url: '/login/two-factor/{method}/code',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
requestCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return requestCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
requestCode.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestCode.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
requestCode.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: requestCode.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
    const requestCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: requestCode.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
        requestCodeForm.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: requestCode.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:442
 * @route '/login/two-factor/{method}/code'
 */
        requestCodeForm.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: requestCode.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    requestCode.form = requestCodeForm
/**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
export const verifyCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyCode.url(args, options),
    method: 'post',
})

verifyCode.definition = {
    methods: ["post"],
    url: '/login/two-factor/{method}/code',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
verifyCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return verifyCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
verifyCode.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyCode.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
    const verifyCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: verifyCode.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:550
 * @route '/login/two-factor/{method}/code'
 */
        verifyCodeForm.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: verifyCode.url(args, options),
            method: 'post',
        })
    
    verifyCode.form = verifyCodeForm
const twoFactor = {
    webauthn: Object.assign(webauthn, webauthn),
enroll: Object.assign(enroll, enroll47ba96),
auth: Object.assign(auth, auth),
recovery: Object.assign(recovery, recovery),
requestCode: Object.assign(requestCode, requestCode),
verifyCode: Object.assign(verifyCode, verifyCode),
}

export default twoFactor